import React from 'react';
import { ContributionSummary, ProductsList } from '@components/common';
import { PriceString } from '@fourthwall/components';
export const DonationItem = ({ donation }) => {
    return (React.createElement(ContributionSummary, { title: "Donation" },
        React.createElement(ContributionSummary.Section, null,
            React.createElement(ProductsList, { size: "large" },
                React.createElement(ProductsList.Item, { name: "Donation", price: React.createElement(PriceString, { ...donation }), donation: true })))));
};
